import PropTypes from 'prop-types'
import {
  HeadSeo,
  OpenGraph,
  TwitterCard,
  Facebook
} from 'gatsby-plugin-head-seo/src'
import { BlogPostingJsonLd } from 'gatsby-plugin-head-seo/src/jsonld'
import { getImage, getSrc } from 'gatsby-plugin-image'
import get from 'lodash/get'

import { useSiteMetadata } from 'hooks'

function SEO(props) {
  const {
    location,
    data,
    pageContext,
    custom
  } = props

  const languageData = data.locales.edges.reduce((acc, edge) => {
    Object.assign(acc, JSON.parse(edge.node.data))
    return acc
  }, {})
  const t = key => get(languageData, key)

  const siteMetadata = useSiteMetadata()
  const { frontmatter } = pageContext

  const frontmatterTitle = frontmatter
    ? `${frontmatter.title} - ${t(`countries.${frontmatter.countryCode}`)} - ${t('seo.title')}`
    : null

  const title = custom.title ?? t(custom.titleMsgId) ?? frontmatterTitle

  const pageTitle = [title, siteMetadata.title].filter(Boolean).join(' | ')

  const description =
    custom.description ??
    t(custom.descriptionMsgId) ??
    frontmatter?.description ??
    t('seo.description')

  const keywords = [
    ...custom.keywords ?? [],
    ...frontmatter?.tags ?? [],
    ...siteMetadata.keywords
  ]

  const language = pageContext.i18n.language

  const image = (data.latestPost?.nodes?.[0] ?? data.post)?.frontmatter.fbImage

  const imageUrl = image
    ? `${siteMetadata.siteUrl}${getSrc(getImage(image))}`
    : null

  return (
    <HeadSeo
      location={location}
      title={pageTitle}
      description={description}
    >
      {({ url }) => (
        <>
          <html lang={language} />
          <meta name="keywords" content={keywords.join(', ')} />
          <OpenGraph
            locale={language}
            og={{
              type: 'website',
              url,
              title,
              description,
              site_name: siteMetadata.title,
              images: imageUrl ? [{
                url: imageUrl,
                width: 1200,
                height: 630,
                alt: title
              }] : []
            }}
          />
          <TwitterCard
            card={{
              type: 'summary',
              site: '@zuyetawarmatik',
              title,
              description,
            }}
          />
          <Facebook appId={siteMetadata.fbAppId} />
          <BlogPostingJsonLd
            blogPosting={{
              '@type': 'BlogPosting',
              mainEntityOfPage: {
                '@type': 'WebPage',
                '@id': url
              },
              headline: title,
              description,
              image: imageUrl ? [imageUrl] : [],
              author: {
                '@type': 'Person',
                name: siteMetadata.author,
              },
              datePublished: frontmatter?.date
            }}
          />
        </>
      )}
    </HeadSeo>
  )
}

const { shape } = PropTypes

SEO.propTypes = {
  location: shape({}).isRequired,
  data: shape({}).isRequired,
  pageContext: shape({}).isRequired,
  custom: shape({})
}

SEO.defaultProps = {
  custom: {}
}

export default SEO
